















































































































import { Component, Vue } from 'vue-property-decorator';
import payment from '@/store/modules/payment';
import user from '@/store/modules/user';
import store from '@/store';
import { HipayTokenization, HipayTokenizedCard } from '@/store/models';
import { deleteTokenizedCard } from '@/store/api';
import handleMessage from '@/commons/messageManager';

@Component({})
export default class HipayCard extends Vue {
    public deletingCard = false;

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get useHostedFields(): boolean {
        return store.state.options.payment.hipay.use_hostedfields;
    }

    get tokenizedCards() {
        return user.customer.extension_attributes.hipay_tokenized_cards;
    }

    set tokenizedCards(value: HipayTokenizedCard[]) {
        user.customer.extension_attributes.hipay_tokenized_cards = value;
    }

    get hipayAdditionalData(): HipayTokenization {
        return payment.additionalData.hipay_tokenization;
    }

    public isExpired(card_expiration: string): boolean {
        const today = new Date();
        const firstDayMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const [expMonth, expYear] = card_expiration.split('/');
        const m = parseInt(expMonth, 10) % 12; // (-1 + 1) months are zero-indexed
        const y = parseInt(expYear, 10) + (m === 0 ? 1 : 0);
        const firstDayExpired = new Date(y, m);

        return firstDayMonth >= firstDayExpired;
    }

    public selectFirstUnexpiredCard() {
        const firstUnexpiredCard = this.tokenizedCards.find((card) => !this.isExpired(card.card_expiration));

        payment.additionalData.hipay_tokenization.tokenId = firstUnexpiredCard ? firstUnexpiredCard.token_id : 0;
    }

    public async deleteCard(tokenizedCardId: number) {
        this.deletingCard = true;

        let statusCode = 0;
        try {
            statusCode = await deleteTokenizedCard(tokenizedCardId);
        } catch (err) {
            if (err.response) {
                statusCode = err.response.status;
            }
        }
        this.deletingCard = false;

        if (statusCode === 200 || statusCode === 404) {
            this.tokenizedCards = this.tokenizedCards.filter((card) => card.token_id !== tokenizedCardId);
            if (this.tokenizedCards.length > 0) {
                handleMessage(
                    'success',
                    `${this.$t('Card deleted.').toString()} ${this.$t(
                        'Use another card or another payment method to continue.',
                    ).toString()}`,
                );
            } else {
                handleMessage(
                    'success',
                    `${this.$t('Card deleted.').toString()} ${this.$t(
                        'Try entering your card details again or use another payment method to continue.',
                    ).toString()}`,
                );
            }
            this.selectFirstUnexpiredCard();
        } else {
            handleMessage('error', this.$t('There was an error deleting your card, please try again later').toString());
        }
    }

    private mounted() {
        const hipayConfig = store.state.options.payment.hipay;

        if (hipayConfig.use_hostedfields) {
            payment.unregisterMethod('hipay').then(() => {
                payment.registerMethod({ methodCode: 'hipay', params: hipayConfig });
            });
        }

        if (this.tokenizedCards && this.tokenizedCards.length > 0) {
            this.selectFirstUnexpiredCard();
        }
    }
}
